module.exports = __webpack_public_path__ + "fonts/Adelle_LightItalic.92fc469e.woff";